import { render, staticRenderFns } from "./DropsmartMarketplace.vue?vue&type=template&id=826e722a&scoped=true&"
import script from "./DropsmartMarketplace.vue?vue&type=script&lang=js&"
export * from "./DropsmartMarketplace.vue?vue&type=script&lang=js&"
import style0 from "./DropsmartMarketplace.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DropsmartMarketplace.vue?vue&type=style&index=1&id=826e722a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e722a",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BContainer} from 'bootstrap-vue'
    installComponents(component, {BContainer})
    

export default component.exports